import { CheckCircle2, AlertTriangle, AlertCircle, HelpCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { SemaforoMto } from '@/types/dominio';

const MAP = {
  OK:            { variant: 'ok' as const,     label: 'Al día',           icon: CheckCircle2 },
  WARN:          { variant: 'warn' as const,   label: 'Próximo',          icon: AlertTriangle },
  DANGER:        { variant: 'danger' as const, label: 'Vencido',          icon: AlertCircle },
  SIN_PROGRAMAR: { variant: 'outline' as const,label: 'Sin programar',   icon: HelpCircle },
};

export function SemaforoBadge({ value, dias }: { value: SemaforoMto; dias?: number | null }) {
  const cfg = MAP[value];
  const Icon = cfg.icon;
  return (
    <Badge variant={cfg.variant} className="gap-1">
      <Icon className="h-3 w-3" />
      <span>{cfg.label}</span>
      {typeof dias === 'number' && (
        <span className="opacity-70 ml-0.5">
          {dias < 0 ? `· hace ${Math.abs(dias)}d` : dias === 0 ? '· hoy' : `· en ${dias}d`}
        </span>
      )}
    </Badge>
  );
}
